webpackJsonp([159],{

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionExamRecordDetail_vue__ = __webpack_require__(3046);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a72568_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionExamRecordDetail_vue__ = __webpack_require__(5634);
function injectStyle (ssrContext) {
  __webpack_require__(5632)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69a72568"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionExamRecordDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a72568_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionExamRecordDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createOptionUuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDefaultQuestionOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOptionLetter;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetQuestionAnswerByType;
/* harmony export (immutable) */ __webpack_exports__["k"] = isChoiceQuestion;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumericAnswer;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQuestionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQuestionStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = getQuestionStatusType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQuestionStatusActions;
/* harmony export (immutable) */ __webpack_exports__["m"] = isQuestionRelationEditLocked;
/* unused harmony export isQuestionBaned */
/* harmony export (immutable) */ __webpack_exports__["n"] = isQuestionUsedOrBaned;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQuestionKnowledgeQueryParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = getQuestionSubmitPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__ = __webpack_require__(1505);



var consts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["b" /* consts */], {
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4 // 已作废
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: [{ value: consts.QUESTION_STATUS_NEW, label: '新创建' }, { value: consts.QUESTION_STATUS_UNUSED, label: '未使用' }, { value: consts.QUESTION_STATUS_USING, label: '使用中' }, { value: consts.QUESTION_STATUS_BANNED, label: '已作废' }],
  questionTypeMaps: [{ value: consts.QUESTION_TYPE_SINGLE, label: '单选题' }, { value: consts.QUESTION_TYPE_MULTI, label: '多选题' }, { value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题' }]
};

function createOptionUuid() {
  return 'opt' + Math.random().toString(16).slice(2) + Date.now();
}

function createDefaultQuestionOptions() {
  return ['A', 'B', 'C', 'D'].map(function (letter) {
    return {
      uuid: createOptionUuid(),
      title: '\u9009\u9879' + letter
    };
  });
}

function getOptionLetter(index) {
  return String.fromCharCode(65 + index);
}

function resetQuestionAnswerByType(type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : '';
}

function isChoiceQuestion(type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type));
}

function isNumericAnswer(value) {
  return (/^-?\d+(\.\d+)?$/.test(String(value).trim())
  );
}

function getQuestionTypeLabel(value) {
  var item = opts.questionTypeMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusLabel(value) {
  var item = opts.statusMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusType(status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success';
    case consts.QUESTION_STATUS_USING:
      return 'primary';
    case consts.QUESTION_STATUS_BANNED:
      return 'default';
    default:
      return 'warning';
  }
}

function getQuestionStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!isSuperAdmin) {
    return [];
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功' }];
    case consts.QUESTION_STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功' }];
    default:
      return [];
  }
}

function isQuestionRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.QUESTION_STATUS_UNUSED, consts.QUESTION_STATUS_USING, consts.QUESTION_STATUS_BANNED].includes(Number(status));
}

function isQuestionBaned(id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED;
}

function isQuestionUsedOrBaned(id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING);
}

function buildQuestionKnowledgeQueryParams(form) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(form);
}

function getQuestionSubmitPayload(form) {
  var payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || []
      },
      standard_answer: form.standard_answer
    }
  };

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || [];
  }

  return payload;
}

/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingInstructionSubHeading',
  props: {
    title: {
      type: String,
      required: true
    },
    entityId: {
      type: [Number, String],
      default: null
    },
    fallbackPath: {
      type: String,
      default: '/training/instruction'
    }
  },
  computed: {
    hasEntityId: function hasEntityId() {
      return this.entityId !== null && this.entityId !== undefined && this.entityId !== '';
    }
  },
  methods: {
    onBack: function onBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push(this.fallbackPath);
    }
  }
});

/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingMediaPreview',
  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      viewer: {
        visible: false,
        index: 0
      }
    };
  },

  computed: {
    normalizedFiles: function normalizedFiles() {
      return (this.files || []).filter(function (file) {
        return file && file.url && (file.type === 'img' || file.type === 'video');
      });
    },
    viewerIndex: function viewerIndex() {
      return this.viewer.index;
    },
    activeFile: function activeFile() {
      return this.normalizedFiles[this.viewerIndex] || null;
    },
    canGoPrev: function canGoPrev() {
      return this.viewerIndex > 0;
    },
    canGoNext: function canGoNext() {
      return this.viewerIndex < this.normalizedFiles.length - 1;
    }
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.onKeyup);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyup);
  },

  methods: {
    fileKey: function fileKey(file, index) {
      return file.uid || file.url || index;
    },
    openViewer: function openViewer(index) {
      if (index < 0 || index >= this.normalizedFiles.length) {
        return;
      }
      this.viewer.index = index;
      this.viewer.visible = true;
    },
    closeViewer: function closeViewer() {
      this.viewer.visible = false;
    },
    onViewerOpened: function onViewerOpened() {
      this.pauseVideo();
    },
    onViewerClosed: function onViewerClosed() {
      this.pauseVideo();
      this.viewer.index = 0;
    },
    viewIndex: function viewIndex(index) {
      if (index === this.viewerIndex || index < 0 || index >= this.normalizedFiles.length) {
        return;
      }
      this.pauseVideo();
      this.viewer.index = index;
    },
    viewPrev: function viewPrev() {
      if (!this.canGoPrev) {
        return;
      }
      this.viewIndex(this.viewerIndex - 1);
    },
    viewNext: function viewNext() {
      if (!this.canGoNext) {
        return;
      }
      this.viewIndex(this.viewerIndex + 1);
    },
    pauseVideo: function pauseVideo() {
      var player = this.$refs.videoPlayer;
      if (player && typeof player.pause === 'function') {
        player.pause();
      }
    },
    onKeyup: function onKeyup(event) {
      if (!this.viewer.visible) {
        return;
      }
      if (event.keyCode === 37) {
        this.viewPrev();
      } else if (event.keyCode === 39) {
        this.viewNext();
      }
    }
  }
});

/***/ }),

/***/ 1612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1666)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67108e77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c279ecb4", content, true, {});

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px}.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0}.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4}.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0}.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingInstructionSubHeading.vue"],"names":[],"mappings":"AACA,mDAAmD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,CACpM,AACD,yDAAyD,oBAAoB,aAAa,CACzF,AACD,0DAA0D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,mBAAmB,eAAe,SAAS,eAAe,gBAAgB,cAAc,eAAe,CAC/R,AACD,+DAA+D,WAAW,CACzE,AACD,6DAA6D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,oBAAoB,cAAc,gBAAgB,kBAAkB,eAAe,gBAAgB,iBAAiB,cAAc,mBAAmB,yBAAyB,iCAAiC,CACvZ","file":"TrainingInstructionSubHeading.vue","sourcesContent":["\n.training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px\n}\n.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0\n}\n.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4\n}\n.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0\n}\n.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-instruction-sub-heading"},[_c('el-button',{staticClass:"training-instruction-sub-heading__back",attrs:{"icon":"el-icon-arrow-left","circle":""},on:{"click":_vm.onBack}}),_vm._v(" "),_c('h2',{staticClass:"training-instruction-sub-heading__title"},[_c('span',{staticClass:"training-instruction-sub-heading__title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasEntityId)?_c('span',{staticClass:"training-instruction-sub-heading__id-badge"},[_vm._v("ID："+_vm._s(_vm.entityId))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return opts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY; });
var consts = {
  SOURCE_TYPE_TASK: 1,
  SOURCE_TYPE_LEARNING_CENTER: 2,
  SOURCE_TYPE_ASSIGN: 3,

  STATUS_LEARNING: 1,
  STATUS_LEARN_FINISHED: 2,
  STATUS_WAIT_EXAM: 3,
  STATUS_ON_EXAM: 4,
  STATUS_PASSED: 5,
  STATUS_EXAM_NOT_PASS: 6,
  STATUS_EXAM_WAIT_RETRY: 7,

  EXAMINATION_STATUS_NOT_START: 0,
  EXAMINATION_STATUS_WAIT_SUBMIT: 1,
  EXAMINATION_STATUS_PASS: 2,
  EXAMINATION_STATUS_NOT_PASS: 3,
  EXAMINATION_STATUS_SUBMITTED: 4
};

var opts = {
  sourceTypeMaps: [{ value: consts.SOURCE_TYPE_TASK, label: '批次任务' }, { value: consts.SOURCE_TYPE_LEARNING_CENTER, label: '学习中心' }, { value: consts.SOURCE_TYPE_ASSIGN, label: '管理员分配' }],
  recordStatusMaps: [{ value: consts.STATUS_LEARNING, label: '学习中' }, { value: consts.STATUS_LEARN_FINISHED, label: '已学完' }, { value: consts.STATUS_WAIT_EXAM, label: '待考试' }, { value: consts.STATUS_ON_EXAM, label: '考试中' }, { value: consts.STATUS_PASSED, label: '通过' }, { value: consts.STATUS_EXAM_NOT_PASS, label: '考试未通过' }, { value: consts.STATUS_EXAM_WAIT_RETRY, label: '待重考' }],
  examinationStatusMaps: [{ value: consts.EXAMINATION_STATUS_NOT_START, label: '未开始' }, { value: consts.EXAMINATION_STATUS_WAIT_SUBMIT, label: '待提交' }, { value: consts.EXAMINATION_STATUS_PASS, label: '通过' }, { value: consts.EXAMINATION_STATUS_NOT_PASS, label: '不通过' }, { value: consts.EXAMINATION_STATUS_SUBMITTED, label: '已提交' }]
};

var TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-record-list';
var TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-exam-record-list';

/***/ }),

/***/ 1807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingMediaPreview_vue__ = __webpack_require__(1608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b0b448_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingMediaPreview_vue__ = __webpack_require__(1812);
function injectStyle (ssrContext) {
  __webpack_require__(1808)
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94b0b448"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingMediaPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b0b448_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingMediaPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1808:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1809);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1390a59c", content, true, {});

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-media-preview[data-v-94b0b448]{margin-top:10px}.training-media-preview__grid[data-v-94b0b448]{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:10px;max-width:640px}.training-media-preview__item[data-v-94b0b448]{position:relative;aspect-ratio:1;border-radius:8px;overflow:hidden;cursor:pointer;background:#f2f2f2;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.08);box-shadow:0 2px 8px rgba(0,0,0,.08)}.training-media-preview__thumb[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-media-preview__video[data-v-94b0b448]{position:relative;width:100%;height:100%;background:#eef2f7}.training-media-preview__video-placeholder[data-v-94b0b448]{width:100%;height:100%;color:#c0c4cc;font-size:28px}.training-media-preview__play-overlay[data-v-94b0b448],.training-media-preview__video-placeholder[data-v-94b0b448]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.training-media-preview__play-overlay[data-v-94b0b448]{position:absolute;inset:0;background:rgba(15,23,42,.12)}.training-media-preview__play-overlay i[data-v-94b0b448]{width:44px;height:44px;border-radius:50%;background:rgba(64,158,255,.88);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:24px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.18);box-shadow:0 4px 12px rgba(0,0,0,.18)}.training-media-preview__viewer[data-v-94b0b448]{position:relative;width:100%;height:100vh;background:rgba(0,0,0,.92);overflow:hidden}.training-media-preview__viewer-close[data-v-94b0b448]{position:absolute;top:0;right:0;z-index:2003;background-color:hsla(0,0%,100%,.1);padding:30px;border:0;border-radius:0 0 0 100%;cursor:pointer}.training-media-preview__viewer-close[data-v-94b0b448]:hover{background-color:hsla(0,0%,100%,.2)}.training-media-preview__viewer-close i[data-v-94b0b448]{color:#fff;font-size:18px}.training-media-preview__viewer-counter[data-v-94b0b448]{position:absolute;top:10px;left:10px;z-index:2002;color:#909399;text-shadow:0 0 2px #000}.training-media-preview__viewer-counter-current[data-v-94b0b448]{font-size:22px;color:#fff}.training-media-preview__viewer-counter-total[data-v-94b0b448]{font-size:14px}.training-media-preview__viewer-body[data-v-94b0b448]{width:100%;height:calc(100% - 72px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:40px 72px 0;-webkit-box-sizing:border-box;box-sizing:border-box}.training-media-preview__viewer-image[data-v-94b0b448]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.training-media-preview__viewer-video[data-v-94b0b448]{max-width:100%;max-height:100%;background:#000}.training-media-preview__viewer-nav[data-v-94b0b448]{z-index:2002}.training-media-preview__viewer-navbar[data-v-94b0b448]{position:absolute;left:0;right:0;bottom:0;z-index:2002;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:12px 16px 16px;overflow-x:auto;background:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.55)),to(transparent));background:linear-gradient(0deg,rgba(0,0,0,.55),transparent)}.training-media-preview__viewer-nav-item[data-v-94b0b448]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:56px;height:56px;border-radius:4px;overflow:hidden;cursor:pointer;opacity:.65;border:2px solid transparent;background:hsla(0,0%,100%,.08)}.training-media-preview__viewer-nav-item.is-active[data-v-94b0b448]{opacity:1;border-color:#409eff}.training-media-preview__viewer-nav-item img[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-media-preview__viewer-nav-video[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:22px}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingMediaPreview.vue"],"names":[],"mappings":"AACA,yCAAyC,eAAe,CACvD,AACD,+CAA+C,aAAa,0DAA4D,SAAS,eAAe,CAC/I,AACD,+CAA+C,kBAAkB,eAAe,kBAAkB,gBAAgB,eAAe,mBAAmB,6CAA8C,oCAAqC,CACtO,AACD,gDAAgD,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACxH,AACD,gDAAgD,kBAAkB,WAAW,YAAY,kBAAkB,CAC1G,AACD,4DAA4D,WAAW,YAAY,AAA2L,cAAc,cAAc,CACzS,AACD,mHAFmF,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,sBAAuB,CAG7Q,AADD,uDAAuD,kBAAkB,QAAQ,AAA2L,6BAA8B,CACzS,AACD,yDAAyD,WAAW,YAAY,kBAAkB,gCAAiC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,eAAe,8CAA+C,qCAAsC,CAC5a,AACD,iDAAiD,kBAAkB,WAAW,aAAa,2BAA4B,eAAe,CACrI,AACD,uDAAuD,kBAAkB,MAAM,QAAQ,aAAa,oCAAuC,aAAa,SAAS,yBAAyB,cAAc,CACvM,AACD,6DAA6D,mCAAsC,CAClG,AACD,yDAAyD,WAAW,cAAc,CACjF,AACD,yDAAyD,kBAAkB,SAAS,UAAU,aAAa,cAAc,wBAAwB,CAChJ,AACD,iEAAiE,eAAe,UAAU,CACzF,AACD,+DAA+D,cAAc,CAC5E,AACD,sDAAsD,WAAW,yBAAyB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,8BAA8B,qBAAqB,CAC3V,AACD,uDAAuD,eAAe,gBAAgB,sBAAsB,kBAAkB,CAC7H,AACD,uDAAuD,eAAe,gBAAgB,eAAe,CACpG,AACD,qDAAqD,YAAY,CAChE,AACD,wDAAwD,kBAAkB,OAAO,QAAQ,SAAS,aAAa,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,uBAAuB,gBAAgB,+FAAoG,4DAAiE,CAC3b,AACD,0DAA0D,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,YAAa,6BAA6B,8BAAiC,CAC/P,AACD,oEAAoE,UAAU,oBAAoB,CACjG,AACD,8DAA8D,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACtI,AACD,2DAA2D,WAAW,YAAY,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,cAAc,CACrS","file":"TrainingMediaPreview.vue","sourcesContent":["\n.training-media-preview[data-v-94b0b448]{margin-top:10px\n}\n.training-media-preview__grid[data-v-94b0b448]{display:grid;grid-template-columns:repeat(auto-fill, minmax(120px, 1fr));gap:10px;max-width:640px\n}\n.training-media-preview__item[data-v-94b0b448]{position:relative;aspect-ratio:1;border-radius:8px;overflow:hidden;cursor:pointer;background:#f2f2f2;-webkit-box-shadow:0 2px 8px rgba(0,0,0,0.08);box-shadow:0 2px 8px rgba(0,0,0,0.08)\n}\n.training-media-preview__thumb[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-media-preview__video[data-v-94b0b448]{position:relative;width:100%;height:100%;background:#eef2f7\n}\n.training-media-preview__video-placeholder[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#c0c4cc;font-size:28px\n}\n.training-media-preview__play-overlay[data-v-94b0b448]{position:absolute;inset:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:rgba(15,23,42,0.12)\n}\n.training-media-preview__play-overlay i[data-v-94b0b448]{width:44px;height:44px;border-radius:50%;background:rgba(64,158,255,0.88);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:24px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,0.18);box-shadow:0 4px 12px rgba(0,0,0,0.18)\n}\n.training-media-preview__viewer[data-v-94b0b448]{position:relative;width:100%;height:100vh;background:rgba(0,0,0,0.92);overflow:hidden\n}\n.training-media-preview__viewer-close[data-v-94b0b448]{position:absolute;top:0;right:0;z-index:2003;background-color:rgba(255,255,255,0.1);padding:30px;border:0;border-radius:0 0 0 100%;cursor:pointer\n}\n.training-media-preview__viewer-close[data-v-94b0b448]:hover{background-color:rgba(255,255,255,0.2)\n}\n.training-media-preview__viewer-close i[data-v-94b0b448]{color:#fff;font-size:18px\n}\n.training-media-preview__viewer-counter[data-v-94b0b448]{position:absolute;top:10px;left:10px;z-index:2002;color:#909399;text-shadow:0 0 2px #000\n}\n.training-media-preview__viewer-counter-current[data-v-94b0b448]{font-size:22px;color:#fff\n}\n.training-media-preview__viewer-counter-total[data-v-94b0b448]{font-size:14px\n}\n.training-media-preview__viewer-body[data-v-94b0b448]{width:100%;height:calc(100% - 72px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:40px 72px 0;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.training-media-preview__viewer-image[data-v-94b0b448]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain\n}\n.training-media-preview__viewer-video[data-v-94b0b448]{max-width:100%;max-height:100%;background:#000\n}\n.training-media-preview__viewer-nav[data-v-94b0b448]{z-index:2002\n}\n.training-media-preview__viewer-navbar[data-v-94b0b448]{position:absolute;left:0;right:0;bottom:0;z-index:2002;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:12px 16px 16px;overflow-x:auto;background:-webkit-gradient(linear, left bottom, left top, from(rgba(0,0,0,0.55)), to(transparent));background:linear-gradient(to top, rgba(0,0,0,0.55), transparent)\n}\n.training-media-preview__viewer-nav-item[data-v-94b0b448]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:56px;height:56px;border-radius:4px;overflow:hidden;cursor:pointer;opacity:0.65;border:2px solid transparent;background:rgba(255,255,255,0.08)\n}\n.training-media-preview__viewer-nav-item.is-active[data-v-94b0b448]{opacity:1;border-color:#409eff\n}\n.training-media-preview__viewer-nav-item img[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-media-preview__viewer-nav-video[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:22px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1810:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7b823748", content, true, {});

/***/ }),

/***/ 1811:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-media-preview__viewer-dialog{margin:0!important;background:transparent;-webkit-box-shadow:none;box-shadow:none}.training-media-preview__viewer-dialog .el-dialog__header{display:none}.training-media-preview__viewer-dialog .el-dialog__body{padding:0}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingMediaPreview.vue"],"names":[],"mappings":"AACA,uCAAuC,mBAAoB,uBAAuB,wBAAwB,eAAe,CACxH,AACD,0DAA0D,YAAY,CACrE,AACD,wDAAwD,SAAS,CAChE","file":"TrainingMediaPreview.vue","sourcesContent":["\n.training-media-preview__viewer-dialog{margin:0 !important;background:transparent;-webkit-box-shadow:none;box-shadow:none\n}\n.training-media-preview__viewer-dialog .el-dialog__header{display:none\n}\n.training-media-preview__viewer-dialog .el-dialog__body{padding:0\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.normalizedFiles.length)?_c('div',{staticClass:"training-media-preview"},[_c('div',{staticClass:"training-media-preview__grid"},_vm._l((_vm.normalizedFiles),function(file,index){return _c('div',{key:_vm.fileKey(file, index),staticClass:"training-media-preview__item",on:{"click":function($event){return _vm.openViewer(index)}}},[(file.type === 'img')?_c('img',{staticClass:"training-media-preview__thumb",attrs:{"src":file.url,"alt":""}}):(file.type === 'video')?_c('div',{staticClass:"training-media-preview__video"},[_vm._m(0,true),_vm._v(" "),_vm._m(1,true)]):_vm._e()])}),0),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.viewer.visible,"width":"100%","top":"0","append-to-body":"","custom-class":"training-media-preview__viewer-dialog","close-on-click-modal":false,"close-on-press-escape":true,"show-close":false},on:{"update:visible":function($event){return _vm.$set(_vm.viewer, "visible", $event)},"closed":_vm.onViewerClosed,"opened":_vm.onViewerOpened}},[(_vm.viewer.visible)?_c('div',{staticClass:"training-media-preview__viewer"},[_c('button',{staticClass:"training-media-preview__viewer-close el-dialog__headerbtn",attrs:{"type":"button"},on:{"click":_vm.closeViewer}},[_c('i',{staticClass:"el-dialog__close el-icon el-icon-close"})]),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-counter"},[_c('span',{staticClass:"training-media-preview__viewer-counter-current"},[_vm._v(_vm._s(_vm.viewerIndex + 1))]),_vm._v(" "),_c('span',{staticClass:"training-media-preview__viewer-counter-total"},[_vm._v("/"+_vm._s(_vm.normalizedFiles.length))])]),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-body"},[(_vm.activeFile && _vm.activeFile.type === 'img')?_c('img',{key:'img-' + _vm.viewerIndex,staticClass:"training-media-preview__viewer-image",attrs:{"src":_vm.activeFile.url,"alt":""}}):(_vm.activeFile && _vm.activeFile.type === 'video')?_c('video',{key:'video-' + _vm.viewerIndex,ref:"videoPlayer",staticClass:"training-media-preview__viewer-video",attrs:{"src":_vm.activeFile.url,"controls":"","autoplay":"","playsinline":""}}):_vm._e()]),_vm._v(" "),(_vm.canGoPrev)?_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__prev training-media-preview__viewer-nav",on:{"click":_vm.viewPrev}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),(_vm.canGoNext)?_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__next training-media-preview__viewer-nav",on:{"click":_vm.viewNext}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-navbar"},_vm._l((_vm.normalizedFiles),function(file,index){return _c('div',{key:'nav-' + _vm.fileKey(file, index),class:['training-media-preview__viewer-nav-item', { 'is-active': _vm.viewerIndex === index }],on:{"click":function($event){return _vm.viewIndex(index)}}},[(file.type === 'img')?_c('img',{attrs:{"src":file.url,"alt":""}}):_c('div',{staticClass:"training-media-preview__viewer-nav-video"},[_c('i',{staticClass:"el-icon-video-camera"})])])}),0)]):_vm._e()])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-media-preview__video-placeholder"},[_c('i',{staticClass:"el-icon-video-camera"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-media-preview__play-overlay"},[_c('i',{staticClass:"el-icon-video-play"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["i"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getExamStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getExamStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getExamStatusActions;
/* harmony export (immutable) */ __webpack_exports__["o"] = isExamStructureLocked;
/* harmony export (immutable) */ __webpack_exports__["l"] = isExamReadonly;
/* harmony export (immutable) */ __webpack_exports__["m"] = isExamScopeLocked;
/* harmony export (immutable) */ __webpack_exports__["n"] = isExamScoreLocked;
/* harmony export (immutable) */ __webpack_exports__["j"] = isExamAnswerLocked;
/* harmony export (immutable) */ __webpack_exports__["k"] = isExamOptionStructureLocked;
/* unused harmony export createExamQuestionClientId */
/* harmony export (immutable) */ __webpack_exports__["c"] = createExamQuestion;
/* harmony export (immutable) */ __webpack_exports__["p"] = normalizeExamQuestionFromRow;
/* unused harmony export getExamQuestionSubmitPayload */
/* harmony export (immutable) */ __webpack_exports__["h"] = getExamSubmitPayload;
/* unused harmony export TRAINING_EXAM_COPY_TYPE */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["q"] = normalizeTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getExamQuestionDuplicateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__ = __webpack_require__(1526);






var consts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["b" /* consts */], {
  OPEN_BOOK_EXAM_OPEN: 1,
  OPEN_BOOK_EXAM_CLOSED: 2,
  SORT_TYPE_FIXED: 1,
  SORT_TYPE_RANDOM: 2
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].statusMaps,
  openBookMaps: [{ value: consts.OPEN_BOOK_EXAM_OPEN, label: '开卷' }, { value: consts.OPEN_BOOK_EXAM_CLOSED, label: '闭卷' }],
  sortTypeMaps: [{ value: consts.SORT_TYPE_FIXED, label: '固定顺序' }, { value: consts.SORT_TYPE_RANDOM, label: '乱序' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getExamStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getExamStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getExamStatusActions(status) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingExamination', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{
        name: 'offline',
        label: '下架',
        type: 'warning',
        apiName: 'offlineTrainingExamination',
        successText: '下架成功'
      }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingExamination', successText: '作废成功' }, { name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingExamination', successText: '上架成功' }];
    case consts.STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingExamination', successText: '激活成功' }];
    default:
      return [];
  }
}

function isExamStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamReadonly(status) {
  return Number(status) === consts.STATUS_BANNED;
}

function isExamScopeLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_OFFLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamScoreLocked(status) {
  return Number(status) !== consts.STATUS_NEW;
}

function isExamAnswerLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamOptionStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function createExamQuestionClientId() {
  return 'examq' + Math.random().toString(16).slice(2) + Date.now();
}

function createExamQuestion() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var questionType = Number(type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    client_id: createExamQuestionClientId(),
    source_question_id: null,
    target_usertype: null,
    customerid: null,
    training_knowledge_id: null,
    question_type: questionType,
    title: '',
    sample_files: [],
    options: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType) ? Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])() : [],
    standard_answer: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: '',
    analysis_files: []
  }, overrides);
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}

// 格式化每个题目，扁平化，原因是题目组件当时重新组装了form，这里复用组件也需要重新组装一下后端或者粘贴的题目结构
function normalizeExamQuestionFromRow(row) {
  var questionJson = row.question_json || {};
  var analysis = questionJson.question_analysis || {};
  var questionType = Number(row.question_type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var standardAnswer = hasValue(questionJson.standard_answer) ? questionJson.standard_answer : row.standard_answer;

  return createExamQuestion(questionType, {
    title: row.title || questionJson.title || '',
    source_question_id: row.id || null,
    target_usertype: hasValue(row.target_usertype) ? row.target_usertype : null,
    customerid: hasValue(row.customerid) ? row.customerid : null,
    training_knowledge_id: hasValue(row.training_knowledge_id) ? row.training_knowledge_id : null,
    sample_files: Array.isArray(questionJson.sample_files) ? questionJson.sample_files : [],
    options: Array.isArray(questionJson.options) ? questionJson.options : [],
    standard_answer: hasValue(standardAnswer) ? standardAnswer : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: analysis.analysis_text || '',
    analysis_files: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : []
  });
}

// 格式化每道题目，如果后续没有改动可以复用training-question.constants-getQuestionSubmitPayload方法，先这样各自处理吧
function getExamQuestionSubmitPayload(question) {
  var questionType = Number(question.question_type);
  var questionJson = {
    title: question.title || '',
    sample_files: question.sample_files || [],
    question_analysis: {
      analysis_text: question.analysis_text || '',
      analysis_files: question.analysis_files || []
    },
    standard_answer: question.standard_answer
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType)) {
    questionJson.options = question.options || [];
  }

  return {
    id: question.source_question_id || question.id || null,
    question_type: questionType,
    question_json: questionJson
  };
}

function getExamSubmitPayload(form) {
  return {
    title: form.title,
    target_usertype: String(form.target_usertype),
    is_common: Number(form.is_common),
    customerid: Number(form.customerid) || 0,
    training_knowledge_id: Number(form.training_knowledge_id),
    open_book_exam: Number(form.open_book_exam),
    question_score: Number(form.question_score),
    passing_score: Number(form.passing_score),
    exam_duration: Number(form.exam_duration),
    question_sort_type: Number(form.question_sort_type),
    question_options_sort_type: Number(form.question_options_sort_type),
    question_list: (form.question_list || []).map(function (question) {
      return getExamQuestionSubmitPayload(question);
    })
  };
}

var TRAINING_EXAM_COPY_TYPE = 'training-exam';

function buildTrainingExamCopyData(form) {
  var data = getExamSubmitPayload(form);
  return {
    version: 1,
    date: new Date().toISOString(),
    type: TRAINING_EXAM_COPY_TYPE,
    title: data.title,
    data: data
  };
}

function normalizeTrainingExamCopyData(copyData) {
  if (!copyData || copyData.type !== TRAINING_EXAM_COPY_TYPE || !copyData.data) {
    return null;
  }

  var data = copyData.data;
  return {
    title: data.title || '',
    target_usertype: Number(data.target_usertype) || consts.TARGETUSER_TYPE_USER,
    is_common: Number(data.is_common || consts.IS_COMMON_DEDICATED),
    customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
    training_knowledge_id: data.training_knowledge_id || null,
    open_book_exam: Number(data.open_book_exam) || consts.OPEN_BOOK_EXAM_CLOSED,
    question_score: Number(data.question_score) || 10,
    passing_score: Number(data.passing_score) || 60,
    exam_duration: Number(data.exam_duration) || 60,
    question_sort_type: Number(data.question_sort_type) || consts.SORT_TYPE_FIXED,
    question_options_sort_type: Number(data.question_options_sort_type) || consts.SORT_TYPE_FIXED,
    question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
      return normalizeExamQuestionFromRow(item);
    }) : []
  };
}

// 不做前端验证，代码先保留 重复项检查比对的是选项显示的内容，而不是内部的选项 UUID
function getChoiceAnswerIndex(answer, options) {
  return options.findIndex(function (option) {
    return option.uuid === answer;
  });
}

function getChoiceDuplicateAnswer(questionType, questionJson, options) {
  if (Number(questionType) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI) {
    return (Array.isArray(questionJson.standard_answer) ? questionJson.standard_answer : []).map(function (answer) {
      return getChoiceAnswerIndex(answer, options);
    }).sort(function (prev, next) {
      return prev - next;
    });
  }
  return getChoiceAnswerIndex(questionJson.standard_answer, options);
}

function getExamQuestionDuplicateKey(question) {
  var payload = getExamQuestionSubmitPayload(question);
  var questionJson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.question_json);

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(payload.question_type)) {
    var options = Array.isArray(questionJson.options) ? questionJson.options : [];
    // 取标题检测
    questionJson.options = options.map(function (option) {
      return {
        title: option.title || ''
      };
    });
    questionJson.standard_answer = getChoiceDuplicateAnswer(payload.question_type, questionJson, options);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    question_type: payload.question_type,
    question_json: questionJson
  });
}

/***/ }),

/***/ 3046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_training_training_instruction_record_constants__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_exam_constants__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_components_TrainingMediaPreview_vue__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_components_TrainingInstructionSubHeading_vue__ = __webpack_require__(1612);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TrainingMediaPreview: __WEBPACK_IMPORTED_MODULE_2__views_training_components_TrainingMediaPreview_vue__["a" /* default */],
    TrainingInstructionSubHeading: __WEBPACK_IMPORTED_MODULE_3__views_training_components_TrainingInstructionSubHeading_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      loadError: false,
      instructionId: this.$route.params.id,
      recordId: this.$route.params.recordId,
      detail: {
        answer_list: []
      }
    };
  },

  computed: {
    fallbackListPath: function fallbackListPath() {
      return '/training/instruction/exam-records/' + this.instructionId;
    },
    pageHeadingTitle: function pageHeadingTitle() {
      if (this.detail.realname) {
        return '\u7B54\u5377\u8BE6\u60C5 \xB7 ' + this.detail.realname;
      }
      return '答卷详情';
    },
    pageEntityId: function pageEntityId() {
      return this.recordId || null;
    },
    answerCountText: function answerCountText() {
      var count = (this.detail.answer_list || []).length;
      return count ? '\uFF08' + count + ' \u9898\uFF09' : '';
    },
    usertypeTagClass: function usertypeTagClass() {
      var type = Number(this.detail.target_usertype);
      if (type === 2) {
        return 'is-auditor';
      }
      return 'is-worker';
    },
    isOpenBookExam: function isOpenBookExam() {
      return Number(this.detail.open_book_exam) === __WEBPACK_IMPORTED_MODULE_1__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_OPEN;
    },
    statusScoreCardClass: function statusScoreCardClass() {
      var status = Number(this.detail.examination_status);
      if (status === __WEBPACK_IMPORTED_MODULE_0__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_PASS) {
        return 'is-status-pass';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_NOT_PASS) {
        return 'is-status-fail';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_WAIT_SUBMIT) {
        return 'is-status-pending';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_SUBMITTED) {
        return 'is-status-submitted';
      }
      return 'is-status-default';
    }
  },
  created: function created() {
    this.loadDetail();
  },

  methods: {
    goBack: function goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
        return;
      }
      this.$router.push({
        path: this.fallbackListPath,
        query: { title: this.$route.query.title || '' }
      });
    },
    loadDetail: function loadDetail() {
      var _this = this;

      this.loading = true;
      this.loadError = false;
      request.common('getTrainingInstructionExamRecord', { id: this.recordId }).then(function (_ref) {
        var data = _ref.data;

        if (Number(data.training_instruction_id) !== Number(_this.instructionId)) {
          _this.$message.error('答卷与当前培训不匹配');
          _this.goBack();
          return;
        }
        _this.detail = data;
      }).catch(function () {
        _this.loadError = true;
      }).finally(function () {
        _this.loading = false;
      });
    },
    formatOpenBookDash: function formatOpenBookDash(value) {
      if (this.isOpenBookExam) {
        return '-';
      }
      if (value === null || value === undefined || value === '') {
        return 0;
      }
      return value;
    },
    formatOpenBookRate: function formatOpenBookRate() {
      if (this.isOpenBookExam) {
        return '-';
      }
      return this.detail.examination_correct_rate_text || '0%';
    },
    isQuestionAnswered: function isQuestionAnswered(item) {
      return !!(item.user_answer_text && String(item.user_answer_text).trim() && item.user_answer_text !== '-');
    },
    isAnswerGraded: function isAnswerGraded(item) {
      return item.is_correct === true || item.is_correct === false;
    },
    getUserAnswerBoxClass: function getUserAnswerBoxClass(item) {
      if (!this.isQuestionAnswered(item) || !this.isAnswerGraded(item)) {
        return '';
      }
      return item.is_correct ? 'is-correct' : 'is-wrong';
    },
    getResultBadgeClass: function getResultBadgeClass(item) {
      if (!this.isQuestionAnswered(item) || !this.isAnswerGraded(item)) {
        return 'is-neutral';
      }
      return item.is_correct ? 'is-correct' : 'is-wrong';
    },
    shouldShowResultIcon: function shouldShowResultIcon(item) {
      return this.isAnswerGraded(item);
    },
    shouldShowResultScore: function shouldShowResultScore(item) {
      if (!this.isAnswerGraded(item)) {
        return false;
      }
      if (this.isOpenBookExam && item.is_correct) {
        return false;
      }
      return true;
    },
    formatResultScore: function formatResultScore(item) {
      if (!this.isAnswerGraded(item)) {
        return '-';
      }
      if (item.is_correct) {
        return '+' + (item.score || 0) + '\u5206';
      }
      return '0分';
    },
    parseAnswerKeys: function parseAnswerKeys(text) {
      if (!text || text === '-') {
        return [];
      }
      return String(text).split('、').map(function (key) {
        return key.trim();
      }).filter(Boolean);
    },
    getOptionFeedback: function getOptionFeedback(item, option) {
      var questionType = item.question_type;
      if (questionType !== 'single_select' && questionType !== 'multi_select') {
        return { class: '', mark: '' };
      }

      if (!this.isQuestionAnswered(item) || !this.isAnswerGraded(item)) {
        return { class: '', mark: '' };
      }

      var userKeys = this.parseAnswerKeys(item.user_answer_text);
      var standardKeys = this.parseAnswerKeys(item.standard_answer_text);
      var isUser = userKeys.includes(option.key);
      var isStandard = standardKeys.includes(option.key);

      if (isUser && isStandard) {
        return { class: 'is-user-correct', mark: 'check' };
      }
      if (isUser && !isStandard) {
        return { class: 'is-user-wrong', mark: 'close' };
      }
      return { class: '', mark: '' };
    },
    getQuestionTypeTagClass: function getQuestionTypeTagClass(item) {
      var map = {
        single_select: 'is-single',
        multi_select: 'is-multi',
        fill_blank: 'is-fill'
      };
      return map[item.question_type] || 'is-default';
    }
  }
});

/***/ }),

/***/ 5632:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a779047c", content, true, {});

/***/ }),

/***/ 5633:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".exam-record-detail__card[data-v-69a72568]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.exam-record-detail__card+.exam-record-detail__card[data-v-69a72568]{margin-top:16px}.exam-record-detail__card-header[data-v-69a72568]{padding:12px 24px;border-bottom:1px solid #ebeef5;color:#606266;font-size:14px;font-weight:500}.exam-record-detail__card-body[data-v-69a72568]{padding:20px 24px}.exam-record-detail__info-grid[data-v-69a72568]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}.exam-record-detail__info-block[data-v-69a72568]{padding:16px 18px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc}.exam-record-detail__section-title[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin:0 0 14px;font-size:15px;font-weight:600;color:#303133}.exam-record-detail__section-title i[data-v-69a72568]{color:#409eff;font-size:16px}.exam-record-detail__info-list[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px}.exam-record-detail__info-row[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;min-height:22px}.exam-record-detail__info-label[data-v-69a72568]{width:72px;-ms-flex-negative:0;flex-shrink:0;color:#909399;font-size:14px;line-height:22px}.exam-record-detail__info-value[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;color:#303133;font-size:14px;line-height:22px;word-break:break-all}.exam-record-detail__info-value.is-strong[data-v-69a72568]{font-weight:600}.exam-record-detail__usertype-tag[data-v-69a72568]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 10px;border-radius:999px;font-size:12px;font-weight:500;line-height:20px}.exam-record-detail__usertype-tag.is-worker[data-v-69a72568]{background:#dbeafe;color:#1d4ed8}.exam-record-detail__usertype-tag.is-auditor[data-v-69a72568]{background:#ede9fe;color:#6d28d9}.exam-record-detail__section-divider[data-v-69a72568]{height:1px;margin:20px 0;background:#ebeef5}.exam-record-detail__score-section[data-v-69a72568]{margin-bottom:16px}.exam-record-detail__score-cards[data-v-69a72568]{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:12px}.exam-record-detail__score-card[data-v-69a72568]{border-radius:8px;padding:14px 16px;min-height:78px}.exam-record-detail__score-card.is-total[data-v-69a72568]{background:linear-gradient(135deg,#eff6ff,#dbeafe);color:#1d4ed8}.exam-record-detail__score-card.is-score[data-v-69a72568]{background:linear-gradient(135deg,#ecfdf5,#d1fae5);color:#047857}.exam-record-detail__score-card.is-passing[data-v-69a72568]{background:linear-gradient(135deg,#fff7ed,#ffedd5);color:#c2410c}.exam-record-detail__score-card.is-rate[data-v-69a72568]{background:linear-gradient(135deg,#f5f3ff,#ede9fe);color:#6d28d9}.exam-record-detail__score-card.is-status-pass[data-v-69a72568]{background:linear-gradient(135deg,#ecfdf5,#d1fae5);color:#047857}.exam-record-detail__score-card.is-status-fail[data-v-69a72568]{background:linear-gradient(135deg,#fef2f2,#fee2e2);color:#dc2626}.exam-record-detail__score-card.is-status-pending[data-v-69a72568]{background:linear-gradient(135deg,#f3f4f6,#e5e7eb);color:#4b5563}.exam-record-detail__score-card.is-status-submitted[data-v-69a72568]{background:linear-gradient(135deg,#e0f2fe,#bae6fd);color:#0369a1}.exam-record-detail__score-card.is-status-default[data-v-69a72568]{background:linear-gradient(135deg,#f8fafc,#f1f5f9);color:#64748b}.exam-record-detail__score-label[data-v-69a72568]{font-size:13px;margin-bottom:8px;opacity:.9}.exam-record-detail__score-value[data-v-69a72568]{font-size:24px;font-weight:600;line-height:1.2}.exam-record-detail__score-value.is-text[data-v-69a72568]{font-size:18px;line-height:1.35}.exam-record-detail__stat-grid[data-v-69a72568]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}.exam-record-detail__stat-card[data-v-69a72568]{border:1px solid #ebeef5;border-radius:8px;padding:14px 16px;background:#fff}.exam-record-detail__stat-label[data-v-69a72568]{color:#909399;font-size:13px;margin-bottom:8px}.exam-record-detail__stat-value[data-v-69a72568]{font-size:24px;font-weight:600;line-height:1.2}.exam-record-detail__stat-value.is-blue[data-v-69a72568]{color:#409eff}.exam-record-detail__stat-value.is-green[data-v-69a72568]{color:#67c23a}.exam-record-detail__stat-value.is-red[data-v-69a72568]{color:#f56c6c}.exam-record-detail__empty[data-v-69a72568]{padding:32px 0;text-align:center;color:#909399;font-size:14px}.exam-record-detail__question-list[data-v-69a72568]{margin:-4px 0 0}.exam-record-detail__question-item[data-v-69a72568]{padding:20px 0;border-bottom:1px solid #ebeef5}.exam-record-detail__question-item[data-v-69a72568]:first-child{padding-top:4px}.exam-record-detail__question-item[data-v-69a72568]:last-child{border-bottom:none;padding-bottom:4px}.exam-record-detail__question-head[data-v-69a72568]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px;margin-bottom:14px}.exam-record-detail__question-head[data-v-69a72568],.exam-record-detail__question-main[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.exam-record-detail__question-main[data-v-69a72568]{gap:12px;-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.exam-record-detail__question-index[data-v-69a72568]{width:32px;height:32px;border-radius:50%;background:#f0f2f5;color:#606266;font-size:14px;font-weight:600;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0}.exam-record-detail__question-content[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.exam-record-detail__question-meta[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px}.exam-record-detail__question-type-tag[data-v-69a72568]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 10px;border-radius:999px;font-size:12px;font-weight:500;line-height:20px}.exam-record-detail__question-type-tag.is-single[data-v-69a72568]{background:#dbeafe;color:#1d4ed8}.exam-record-detail__question-type-tag.is-multi[data-v-69a72568]{background:#ede9fe;color:#6d28d9}.exam-record-detail__question-type-tag.is-fill[data-v-69a72568]{background:#dcfce7;color:#15803d}.exam-record-detail__question-type-tag.is-default[data-v-69a72568]{background:#f3f4f6;color:#4b5563}.exam-record-detail__question-score[data-v-69a72568]{color:#909399;font-size:13px}.exam-record-detail__question-title[data-v-69a72568]{margin:0;color:#303133;font-size:15px;line-height:1.65}.exam-record-detail__result-badge[data-v-69a72568]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;padding:8px 14px;border-radius:8px;font-size:14px;font-weight:600;-ms-flex-negative:0;flex-shrink:0;white-space:nowrap}.exam-record-detail__result-badge.is-correct[data-v-69a72568]{background:#ecfdf5;color:#047857}.exam-record-detail__result-badge.is-wrong[data-v-69a72568]{background:#fef2f2;color:#dc2626}.exam-record-detail__result-badge.is-neutral[data-v-69a72568]{background:#f5f7fa;color:#909399}.exam-record-detail__options[data-v-69a72568]{margin:0 0 14px 44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px}.exam-record-detail__option-item[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;background:#f5f7fa;border:1px solid transparent;-webkit-transition:background-color .15s ease,border-color .15s ease;transition:background-color .15s ease,border-color .15s ease}.exam-record-detail__option-item.is-user-correct[data-v-69a72568]{background:#ecfdf5;border-color:#bbf7d0}.exam-record-detail__option-item.is-user-wrong[data-v-69a72568]{background:#fef2f2;border-color:#fecaca}.exam-record-detail__option-key[data-v-69a72568]{width:24px;height:24px;border-radius:50%;border:1px solid #dcdfe6;background:#fff;color:#606266;font-size:12px;font-weight:600;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0}.exam-record-detail__option-title[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;color:#606266;font-size:14px;line-height:24px}.exam-record-detail__option-mark[data-v-69a72568]{-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:600;line-height:24px}.exam-record-detail__option-mark.is-correct[data-v-69a72568]{color:#047857}.exam-record-detail__option-mark.is-wrong[data-v-69a72568]{color:#dc2626}.exam-record-detail__answer-block[data-v-69a72568]{margin-left:44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px}.exam-record-detail__answer-row[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px}.exam-record-detail__answer-label[data-v-69a72568]{width:72px;-ms-flex-negative:0;flex-shrink:0;padding-top:8px;color:#909399;font-size:14px;line-height:22px}.exam-record-detail__answer-box[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;padding:8px 14px;border-radius:8px;font-size:14px;line-height:1.65;word-break:break-word}.exam-record-detail__answer-box[data-v-69a72568]:not(.is-correct):not(.is-wrong):not(.is-standard):not(.is-analysis){background:#f5f7fa;border:1px solid #ebeef5;color:#606266}.exam-record-detail__answer-box.is-correct[data-v-69a72568]{background:#ecfdf5;border:1px solid #bbf7d0;color:#047857;font-weight:500}.exam-record-detail__answer-box.is-wrong[data-v-69a72568]{background:#fef2f2;border:1px solid #fecaca;color:#dc2626;font-weight:500}.exam-record-detail__answer-box.is-standard[data-v-69a72568]{background:#eff6ff;border:1px solid #bfdbfe;color:#1d4ed8;font-weight:500}.exam-record-detail__answer-box.is-analysis[data-v-69a72568]{background:#fffbeb;border:1px solid #fde68a;color:#92400e}.exam-record-detail__answer-box.is-analysis p[data-v-69a72568]{margin:0}.exam-record-detail__footer[data-v-69a72568]{margin:16px 0 8px;text-align:center}@media (max-width:1200px){.exam-record-detail__score-cards[data-v-69a72568]{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (max-width:992px){.exam-record-detail__info-grid[data-v-69a72568],.exam-record-detail__stat-grid[data-v-69a72568]{grid-template-columns:1fr}.exam-record-detail__score-cards[data-v-69a72568]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.exam-record-detail__question-head[data-v-69a72568]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.exam-record-detail__result-badge[data-v-69a72568]{margin-left:44px}.exam-record-detail__answer-block[data-v-69a72568],.exam-record-detail__options[data-v-69a72568]{margin-left:0}.exam-record-detail__score-cards[data-v-69a72568]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionExamRecordDetail.vue"],"names":[],"mappings":"AACA,2CAA2C,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CAC/K,AACD,qEAAqE,eAAe,CACnF,AACD,kDAAkD,kBAAkB,gCAAgC,cAAc,eAAe,eAAe,CAC/I,AACD,gDAAgD,iBAAiB,CAChE,AACD,gDAAgD,aAAa,8CAAgD,QAAQ,CACpH,AACD,iDAAiD,kBAAkB,yBAAyB,kBAAkB,kBAAkB,CAC/H,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,gBAAgB,eAAe,gBAAgB,aAAa,CAC9O,AACD,sDAAsD,cAAc,cAAc,CACjF,AACD,gDAAgD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,CACrN,AACD,+CAA+C,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,SAAS,eAAe,CAC/L,AACD,iDAAiD,WAAW,oBAAoB,cAAc,cAAc,eAAe,gBAAgB,CAC1I,AACD,iDAAiD,mBAAmB,WAAW,OAAO,YAAY,cAAc,eAAe,iBAAiB,oBAAoB,CACnK,AACD,2DAA2D,eAAe,CACzE,AACD,mDAAmD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,oBAAoB,eAAe,gBAAgB,gBAAgB,CAClR,AACD,6DAA6D,mBAAmB,aAAa,CAC5F,AACD,8DAA8D,mBAAmB,aAAa,CAC7F,AACD,sDAAsD,WAAW,cAAc,kBAAkB,CAChG,AACD,oDAAoD,kBAAkB,CACrE,AACD,kDAAkD,aAAa,8CAAgD,QAAQ,CACtH,AACD,iDAAiD,kBAAkB,kBAAkB,eAAe,CACnG,AACD,0DAA0D,mDAAqD,aAAa,CAC3H,AACD,0DAA0D,mDAAqD,aAAa,CAC3H,AACD,4DAA4D,mDAAqD,aAAa,CAC7H,AACD,yDAAyD,mDAAqD,aAAa,CAC1H,AACD,gEAAgE,mDAAqD,aAAa,CACjI,AACD,gEAAgE,mDAAqD,aAAa,CACjI,AACD,mEAAmE,mDAAqD,aAAa,CACpI,AACD,qEAAqE,mDAAqD,aAAa,CACtI,AACD,mEAAmE,mDAAqD,aAAa,CACpI,AACD,kDAAkD,eAAe,kBAAkB,UAAW,CAC7F,AACD,kDAAkD,eAAe,gBAAgB,eAAe,CAC/F,AACD,0DAA0D,eAAe,gBAAgB,CACxF,AACD,gDAAgD,aAAa,8CAAgD,QAAQ,CACpH,AACD,gDAAgD,yBAAyB,kBAAkB,kBAAkB,eAAe,CAC3H,AACD,iDAAiD,cAAc,eAAe,iBAAiB,CAC9F,AACD,iDAAiD,eAAe,gBAAgB,eAAe,CAC9F,AACD,yDAAyD,aAAa,CACrE,AACD,0DAA0D,aAAa,CACtE,AACD,wDAAwD,aAAa,CACpE,AACD,4CAA4C,eAAe,kBAAkB,cAAc,cAAc,CACxG,AACD,oDAAoD,eAAe,CAClE,AACD,oDAAoD,eAAe,+BAA+B,CACjG,AACD,gEAAgE,eAAe,CAC9E,AACD,+DAA+D,mBAAmB,kBAAkB,CACnG,AACD,oDAA6K,yBAAyB,sBAAsB,8BAA8B,SAAS,kBAAkB,CACpR,AACD,wGAFoD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAuB,CAG5K,AADD,oDAA6K,SAAS,mBAAmB,WAAW,OAAO,WAAW,CACrO,AACD,qDAAqD,WAAW,YAAY,kBAAkB,mBAAmB,cAAc,eAAe,gBAAgB,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,aAAa,CAC9Y,AACD,uDAAuD,mBAAmB,WAAW,OAAO,WAAW,CACtG,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,iBAAiB,CACnM,AACD,wDAAwD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,oBAAoB,eAAe,gBAAgB,gBAAgB,CACvR,AACD,kEAAkE,mBAAmB,aAAa,CACjG,AACD,iEAAiE,mBAAmB,aAAa,CAChG,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,mEAAmE,mBAAmB,aAAa,CAClG,AACD,qDAAqD,cAAc,cAAc,CAChF,AACD,qDAAqD,SAAS,cAAc,eAAe,gBAAgB,CAC1G,AACD,mDAAmD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,QAAQ,iBAAiB,kBAAkB,eAAe,gBAAgB,oBAAoB,cAAc,kBAAkB,CAC5T,AACD,8DAA8D,mBAAmB,aAAa,CAC7F,AACD,4DAA4D,mBAAmB,aAAa,CAC3F,AACD,8DAA8D,mBAAmB,aAAa,CAC7F,AACD,8CAA8C,qBAAqB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,OAAO,CACvO,AACD,kDAAkD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,kBAAkB,mBAAmB,6BAA6B,qEAAwE,4DAA+D,CAC5Y,AACD,kEAAkE,mBAAmB,oBAAoB,CACxG,AACD,gEAAgE,mBAAmB,oBAAoB,CACtG,AACD,iDAAiD,WAAW,YAAY,kBAAkB,yBAAyB,gBAAgB,cAAc,eAAe,gBAAgB,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,aAAa,CACha,AACD,mDAAmD,mBAAmB,WAAW,OAAO,YAAY,cAAc,eAAe,gBAAgB,CAChJ,AACD,kDAAkD,oBAAoB,cAAc,eAAe,gBAAgB,gBAAgB,CAClI,AACD,6DAA6D,aAAa,CACzE,AACD,2DAA2D,aAAa,CACvE,AACD,mDAAmD,iBAAiB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,CACzO,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,CACjL,AACD,mDAAmD,WAAW,oBAAoB,cAAc,gBAAgB,cAAc,eAAe,gBAAgB,CAC5J,AACD,iDAAiD,mBAAmB,WAAW,OAAO,YAAY,iBAAiB,kBAAkB,eAAe,iBAAiB,qBAAqB,CACzL,AACD,qHAAqH,mBAAmB,yBAAyB,aAAa,CAC7K,AACD,4DAA4D,mBAAmB,yBAAyB,cAAc,eAAe,CACpI,AACD,0DAA0D,mBAAmB,yBAAyB,cAAc,eAAe,CAClI,AACD,6DAA6D,mBAAmB,yBAAyB,cAAc,eAAe,CACrI,AACD,6DAA6D,mBAAmB,yBAAyB,aAAa,CACrH,AACD,+DAA+D,QAAQ,CACtE,AACD,6CAA6C,kBAAkB,iBAAiB,CAC/E,AACD,0BACA,kDAAkD,6CAA+C,CAChG,CACA,AACD,yBACA,gGAAgG,yBAAyB,CACxH,AACD,kDAAkD,6CAA+C,CAChG,CACA,AACD,yBACA,oDAAoD,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAC3J,AACD,mDAAmD,gBAAgB,CAClE,AACD,iGAAiG,aAAa,CAC7G,AACD,kDAAkD,yBAAyB,CAC1E,CACA","file":"TrainingInstructionExamRecordDetail.vue","sourcesContent":["\n.exam-record-detail__card[data-v-69a72568]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.exam-record-detail__card+.exam-record-detail__card[data-v-69a72568]{margin-top:16px\n}\n.exam-record-detail__card-header[data-v-69a72568]{padding:12px 24px;border-bottom:1px solid #ebeef5;color:#606266;font-size:14px;font-weight:500\n}\n.exam-record-detail__card-body[data-v-69a72568]{padding:20px 24px\n}\n.exam-record-detail__info-grid[data-v-69a72568]{display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));gap:16px\n}\n.exam-record-detail__info-block[data-v-69a72568]{padding:16px 18px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc\n}\n.exam-record-detail__section-title[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin:0 0 14px;font-size:15px;font-weight:600;color:#303133\n}\n.exam-record-detail__section-title i[data-v-69a72568]{color:#409eff;font-size:16px\n}\n.exam-record-detail__info-list[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px\n}\n.exam-record-detail__info-row[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;min-height:22px\n}\n.exam-record-detail__info-label[data-v-69a72568]{width:72px;-ms-flex-negative:0;flex-shrink:0;color:#909399;font-size:14px;line-height:22px\n}\n.exam-record-detail__info-value[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;color:#303133;font-size:14px;line-height:22px;word-break:break-all\n}\n.exam-record-detail__info-value.is-strong[data-v-69a72568]{font-weight:600\n}\n.exam-record-detail__usertype-tag[data-v-69a72568]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 10px;border-radius:999px;font-size:12px;font-weight:500;line-height:20px\n}\n.exam-record-detail__usertype-tag.is-worker[data-v-69a72568]{background:#dbeafe;color:#1d4ed8\n}\n.exam-record-detail__usertype-tag.is-auditor[data-v-69a72568]{background:#ede9fe;color:#6d28d9\n}\n.exam-record-detail__section-divider[data-v-69a72568]{height:1px;margin:20px 0;background:#ebeef5\n}\n.exam-record-detail__score-section[data-v-69a72568]{margin-bottom:16px\n}\n.exam-record-detail__score-cards[data-v-69a72568]{display:grid;grid-template-columns:repeat(5, minmax(0, 1fr));gap:12px\n}\n.exam-record-detail__score-card[data-v-69a72568]{border-radius:8px;padding:14px 16px;min-height:78px\n}\n.exam-record-detail__score-card.is-total[data-v-69a72568]{background:linear-gradient(135deg, #eff6ff, #dbeafe);color:#1d4ed8\n}\n.exam-record-detail__score-card.is-score[data-v-69a72568]{background:linear-gradient(135deg, #ecfdf5, #d1fae5);color:#047857\n}\n.exam-record-detail__score-card.is-passing[data-v-69a72568]{background:linear-gradient(135deg, #fff7ed, #ffedd5);color:#c2410c\n}\n.exam-record-detail__score-card.is-rate[data-v-69a72568]{background:linear-gradient(135deg, #f5f3ff, #ede9fe);color:#6d28d9\n}\n.exam-record-detail__score-card.is-status-pass[data-v-69a72568]{background:linear-gradient(135deg, #ecfdf5, #d1fae5);color:#047857\n}\n.exam-record-detail__score-card.is-status-fail[data-v-69a72568]{background:linear-gradient(135deg, #fef2f2, #fee2e2);color:#dc2626\n}\n.exam-record-detail__score-card.is-status-pending[data-v-69a72568]{background:linear-gradient(135deg, #f3f4f6, #e5e7eb);color:#4b5563\n}\n.exam-record-detail__score-card.is-status-submitted[data-v-69a72568]{background:linear-gradient(135deg, #e0f2fe, #bae6fd);color:#0369a1\n}\n.exam-record-detail__score-card.is-status-default[data-v-69a72568]{background:linear-gradient(135deg, #f8fafc, #f1f5f9);color:#64748b\n}\n.exam-record-detail__score-label[data-v-69a72568]{font-size:13px;margin-bottom:8px;opacity:0.9\n}\n.exam-record-detail__score-value[data-v-69a72568]{font-size:24px;font-weight:600;line-height:1.2\n}\n.exam-record-detail__score-value.is-text[data-v-69a72568]{font-size:18px;line-height:1.35\n}\n.exam-record-detail__stat-grid[data-v-69a72568]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px\n}\n.exam-record-detail__stat-card[data-v-69a72568]{border:1px solid #ebeef5;border-radius:8px;padding:14px 16px;background:#fff\n}\n.exam-record-detail__stat-label[data-v-69a72568]{color:#909399;font-size:13px;margin-bottom:8px\n}\n.exam-record-detail__stat-value[data-v-69a72568]{font-size:24px;font-weight:600;line-height:1.2\n}\n.exam-record-detail__stat-value.is-blue[data-v-69a72568]{color:#409eff\n}\n.exam-record-detail__stat-value.is-green[data-v-69a72568]{color:#67c23a\n}\n.exam-record-detail__stat-value.is-red[data-v-69a72568]{color:#f56c6c\n}\n.exam-record-detail__empty[data-v-69a72568]{padding:32px 0;text-align:center;color:#909399;font-size:14px\n}\n.exam-record-detail__question-list[data-v-69a72568]{margin:-4px 0 0\n}\n.exam-record-detail__question-item[data-v-69a72568]{padding:20px 0;border-bottom:1px solid #ebeef5\n}\n.exam-record-detail__question-item[data-v-69a72568]:first-child{padding-top:4px\n}\n.exam-record-detail__question-item[data-v-69a72568]:last-child{border-bottom:none;padding-bottom:4px\n}\n.exam-record-detail__question-head[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px;margin-bottom:14px\n}\n.exam-record-detail__question-main[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.exam-record-detail__question-index[data-v-69a72568]{width:32px;height:32px;border-radius:50%;background:#f0f2f5;color:#606266;font-size:14px;font-weight:600;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0\n}\n.exam-record-detail__question-content[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.exam-record-detail__question-meta[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px\n}\n.exam-record-detail__question-type-tag[data-v-69a72568]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 10px;border-radius:999px;font-size:12px;font-weight:500;line-height:20px\n}\n.exam-record-detail__question-type-tag.is-single[data-v-69a72568]{background:#dbeafe;color:#1d4ed8\n}\n.exam-record-detail__question-type-tag.is-multi[data-v-69a72568]{background:#ede9fe;color:#6d28d9\n}\n.exam-record-detail__question-type-tag.is-fill[data-v-69a72568]{background:#dcfce7;color:#15803d\n}\n.exam-record-detail__question-type-tag.is-default[data-v-69a72568]{background:#f3f4f6;color:#4b5563\n}\n.exam-record-detail__question-score[data-v-69a72568]{color:#909399;font-size:13px\n}\n.exam-record-detail__question-title[data-v-69a72568]{margin:0;color:#303133;font-size:15px;line-height:1.65\n}\n.exam-record-detail__result-badge[data-v-69a72568]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;padding:8px 14px;border-radius:8px;font-size:14px;font-weight:600;-ms-flex-negative:0;flex-shrink:0;white-space:nowrap\n}\n.exam-record-detail__result-badge.is-correct[data-v-69a72568]{background:#ecfdf5;color:#047857\n}\n.exam-record-detail__result-badge.is-wrong[data-v-69a72568]{background:#fef2f2;color:#dc2626\n}\n.exam-record-detail__result-badge.is-neutral[data-v-69a72568]{background:#f5f7fa;color:#909399\n}\n.exam-record-detail__options[data-v-69a72568]{margin:0 0 14px 44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px\n}\n.exam-record-detail__option-item[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;background:#f5f7fa;border:1px solid transparent;-webkit-transition:background-color 0.15s ease, border-color 0.15s ease;transition:background-color 0.15s ease, border-color 0.15s ease\n}\n.exam-record-detail__option-item.is-user-correct[data-v-69a72568]{background:#ecfdf5;border-color:#bbf7d0\n}\n.exam-record-detail__option-item.is-user-wrong[data-v-69a72568]{background:#fef2f2;border-color:#fecaca\n}\n.exam-record-detail__option-key[data-v-69a72568]{width:24px;height:24px;border-radius:50%;border:1px solid #dcdfe6;background:#fff;color:#606266;font-size:12px;font-weight:600;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0\n}\n.exam-record-detail__option-title[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;color:#606266;font-size:14px;line-height:24px\n}\n.exam-record-detail__option-mark[data-v-69a72568]{-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:600;line-height:24px\n}\n.exam-record-detail__option-mark.is-correct[data-v-69a72568]{color:#047857\n}\n.exam-record-detail__option-mark.is-wrong[data-v-69a72568]{color:#dc2626\n}\n.exam-record-detail__answer-block[data-v-69a72568]{margin-left:44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px\n}\n.exam-record-detail__answer-row[data-v-69a72568]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px\n}\n.exam-record-detail__answer-label[data-v-69a72568]{width:72px;-ms-flex-negative:0;flex-shrink:0;padding-top:8px;color:#909399;font-size:14px;line-height:22px\n}\n.exam-record-detail__answer-box[data-v-69a72568]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;padding:8px 14px;border-radius:8px;font-size:14px;line-height:1.65;word-break:break-word\n}\n.exam-record-detail__answer-box[data-v-69a72568]:not(.is-correct):not(.is-wrong):not(.is-standard):not(.is-analysis){background:#f5f7fa;border:1px solid #ebeef5;color:#606266\n}\n.exam-record-detail__answer-box.is-correct[data-v-69a72568]{background:#ecfdf5;border:1px solid #bbf7d0;color:#047857;font-weight:500\n}\n.exam-record-detail__answer-box.is-wrong[data-v-69a72568]{background:#fef2f2;border:1px solid #fecaca;color:#dc2626;font-weight:500\n}\n.exam-record-detail__answer-box.is-standard[data-v-69a72568]{background:#eff6ff;border:1px solid #bfdbfe;color:#1d4ed8;font-weight:500\n}\n.exam-record-detail__answer-box.is-analysis[data-v-69a72568]{background:#fffbeb;border:1px solid #fde68a;color:#92400e\n}\n.exam-record-detail__answer-box.is-analysis p[data-v-69a72568]{margin:0\n}\n.exam-record-detail__footer[data-v-69a72568]{margin:16px 0 8px;text-align:center\n}\n@media (max-width: 1200px){\n.exam-record-detail__score-cards[data-v-69a72568]{grid-template-columns:repeat(3, minmax(0, 1fr))\n}\n}\n@media (max-width: 992px){\n.exam-record-detail__info-grid[data-v-69a72568],.exam-record-detail__stat-grid[data-v-69a72568]{grid-template-columns:1fr\n}\n.exam-record-detail__score-cards[data-v-69a72568]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.exam-record-detail__question-head[data-v-69a72568]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.exam-record-detail__result-badge[data-v-69a72568]{margin-left:44px\n}\n.exam-record-detail__options[data-v-69a72568],.exam-record-detail__answer-block[data-v-69a72568]{margin-left:0\n}\n.exam-record-detail__score-cards[data-v-69a72568]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"},{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"exam-record-detail"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/instruction' }}},[_vm._v("培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_vm._v("答卷列表")])]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("答卷详情")])],1)],1),_vm._v(" "),_c('training-instruction-sub-heading',{attrs:{"title":_vm.pageHeadingTitle,"entity-id":_vm.pageEntityId,"fallback-path":_vm.fallbackListPath}}),_vm._v(" "),(_vm.loadError)?_c('el-empty',{attrs:{"description":"答卷详情加载失败"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.loadDetail}},[_vm._v("重新加载")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回列表")])],1):[_c('div',{staticClass:"exam-record-detail__card"},[_c('div',{staticClass:"exam-record-detail__card-header"},[_vm._v("答卷信息")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__card-body"},[_c('div',{staticClass:"exam-record-detail__info-grid"},[_c('div',{staticClass:"exam-record-detail__info-block"},[_c('h4',{staticClass:"exam-record-detail__section-title"},[_c('i',{staticClass:"el-icon-user"}),_vm._v("\n          考生信息\n        ")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-list"},[_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("姓名")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value is-strong"},[_vm._v(_vm._s(_vm.detail.realname || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("用户ID")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value"},[_vm._v(_vm._s(_vm.detail.userid || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("省市区")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value"},[_vm._v(_vm._s(_vm.detail.region_name || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("用户类型")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value"},[(_vm.detail.target_usertype_name)?_c('span',{class:['exam-record-detail__usertype-tag', _vm.usertypeTagClass]},[_vm._v("\n                "+_vm._s(_vm.detail.target_usertype_name)+"\n              ")]):_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-block"},[_c('h4',{staticClass:"exam-record-detail__section-title"},[_c('i',{staticClass:"el-icon-document"}),_vm._v("\n          考试信息\n        ")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-list"},[_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("考试名称")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value is-strong"},[_vm._v(_vm._s(_vm.detail.training_examination_title || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("考试ID")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value"},[_vm._v(_vm._s(_vm.detail.training_examination_id || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("提交时间")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value"},[_vm._v(_vm._s(_vm.detail.examination_submitted_at || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__info-row"},[_c('span',{staticClass:"exam-record-detail__info-label"},[_vm._v("答题用时")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__info-value"},[_vm._v(_vm._s(_vm.detail.examination_duration_text || '-'))])])])])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__section-divider"}),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-section"},[_c('h4',{staticClass:"exam-record-detail__section-title"},[_c('i',{staticClass:"el-icon-data-analysis"}),_vm._v("\n        得分情况\n      ")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-cards"},[_c('div',{class:['exam-record-detail__score-card', _vm.statusScoreCardClass]},[_c('div',{staticClass:"exam-record-detail__score-label"},[_vm._v("状态")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-value is-text"},[_vm._v(_vm._s(_vm.detail.examination_status_name || '-'))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-card is-total"},[_c('div',{staticClass:"exam-record-detail__score-label"},[_vm._v("总分")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-value"},[_vm._v(_vm._s(_vm.formatOpenBookDash(_vm.detail.examination_total_score)))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-card is-score"},[_c('div',{staticClass:"exam-record-detail__score-label"},[_vm._v("得分")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-value"},[_vm._v(_vm._s(_vm.formatOpenBookDash(_vm.detail.examination_score)))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-card is-passing"},[_c('div',{staticClass:"exam-record-detail__score-label"},[_vm._v("及格分")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-value"},[_vm._v(_vm._s(_vm.formatOpenBookDash(_vm.detail.examination_passing_score)))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-card is-rate"},[_c('div',{staticClass:"exam-record-detail__score-label"},[_vm._v("正确率")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__score-value"},[_vm._v(_vm._s(_vm.formatOpenBookRate()))])])])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__stat-grid"},[_c('div',{staticClass:"exam-record-detail__stat-card"},[_c('div',{staticClass:"exam-record-detail__stat-label"},[_vm._v("总题数")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__stat-value is-blue"},[_vm._v(_vm._s(_vm.detail.total_question_count || 0))])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__stat-card"},[_c('div',{staticClass:"exam-record-detail__stat-label"},[_vm._v("答对题数")]),_vm._v(" "),_c('div',{class:['exam-record-detail__stat-value', _vm.isOpenBookExam ? '' : 'is-green']},[_vm._v("\n          "+_vm._s(_vm.formatOpenBookDash(_vm.detail.correct_question_count))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__stat-card"},[_c('div',{staticClass:"exam-record-detail__stat-label"},[_vm._v("答错题数")]),_vm._v(" "),_c('div',{class:['exam-record-detail__stat-value', _vm.isOpenBookExam ? '' : 'is-red']},[_vm._v("\n          "+_vm._s(_vm.formatOpenBookDash(_vm.detail.wrong_question_count))+"\n        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__card"},[_c('div',{staticClass:"exam-record-detail__card-header"},[_vm._v("答题详情"+_vm._s(_vm.answerCountText))]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__card-body"},[(!(_vm.detail.answer_list || []).length)?_c('div',{staticClass:"exam-record-detail__empty"},[_vm._v("\n      暂无答题记录\n    ")]):_c('div',{staticClass:"exam-record-detail__question-list"},_vm._l((_vm.detail.answer_list),function(item,index){return _c('div',{key:item.id,staticClass:"exam-record-detail__question-item"},[_c('div',{staticClass:"exam-record-detail__question-head"},[_c('div',{staticClass:"exam-record-detail__question-main"},[_c('span',{staticClass:"exam-record-detail__question-index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__question-content"},[_c('div',{staticClass:"exam-record-detail__question-meta"},[_c('span',{class:['exam-record-detail__question-type-tag', _vm.getQuestionTypeTagClass(item)]},[_vm._v("\n                  "+_vm._s(item.question_type_name || '题目')+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__question-score"},[_vm._v(_vm._s(item.max_score)+" 分")])]),_vm._v(" "),_c('p',{staticClass:"exam-record-detail__question-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('training-media-preview',{attrs:{"files":item.sample_files}})],1)]),_vm._v(" "),_c('div',{class:['exam-record-detail__result-badge', _vm.getResultBadgeClass(item)]},[(_vm.shouldShowResultIcon(item))?_c('i',{class:item.is_correct ? 'el-icon-check' : 'el-icon-close'}):_vm._e(),_vm._v(" "),(_vm.shouldShowResultScore(item))?_c('span',[_vm._v(_vm._s(_vm.formatResultScore(item)))]):_vm._e()])]),_vm._v(" "),((item.options || []).length)?_c('div',{staticClass:"exam-record-detail__options"},_vm._l((item.options),function(option){return _c('div',{key:option.uuid || option.key,class:['exam-record-detail__option-item', _vm.getOptionFeedback(item, option).class]},[_c('span',{staticClass:"exam-record-detail__option-key"},[_vm._v(_vm._s(option.key))]),_vm._v(" "),_c('span',{staticClass:"exam-record-detail__option-title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(_vm.getOptionFeedback(item, option).mark === 'check')?_c('i',{staticClass:"el-icon-check exam-record-detail__option-mark is-correct"}):(_vm.getOptionFeedback(item, option).mark === 'close')?_c('i',{staticClass:"el-icon-close exam-record-detail__option-mark is-wrong"}):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__answer-block"},[_c('div',{staticClass:"exam-record-detail__answer-row"},[_c('span',{staticClass:"exam-record-detail__answer-label"},[_vm._v("零工答案")]),_vm._v(" "),_c('div',{class:['exam-record-detail__answer-box', _vm.getUserAnswerBoxClass(item)]},[_vm._v("\n              "+_vm._s(item.user_answer_text || '-')+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__answer-row"},[_c('span',{staticClass:"exam-record-detail__answer-label"},[_vm._v("正确答案")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__answer-box is-standard"},[_vm._v("\n              "+_vm._s(item.standard_answer_text || '-')+"\n            ")])]),_vm._v(" "),(item.analysis_text || (item.analysis_files || []).length)?_c('div',{staticClass:"exam-record-detail__answer-row"},[_c('span',{staticClass:"exam-record-detail__answer-label"},[_vm._v("答案解析")]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__answer-box is-analysis"},[(item.analysis_text)?_c('p',[_vm._v(_vm._s(item.analysis_text))]):_vm._e(),_vm._v(" "),_c('training-media-preview',{attrs:{"files":item.analysis_files}})],1)]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"exam-record-detail__footer"},[_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回答卷列表")])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-instruction-exam-record-detail.71200a86d0b9f8c95231.js